import { createQuery } from '@luna/api';
import { logger } from '@luna/logger';

import type { MyProfile } from './ProfileTypes';

export type ProfileLoader = () => Promise<MyProfile>;

const notInitializedProfileLoader = (): Promise<MyProfile> => {
    const notInitializedErrorMessage = 'Please setup the profile loader for this application.';
    logger.error(notInitializedErrorMessage);
    throw new Error(notInitializedErrorMessage);
};

let profileLoader: ProfileLoader = notInitializedProfileLoader;

export const [
    useMyProfile,
    {
        selectData: selectMyProfileData,
        queryApiIfNeeded: queryMyProfileIfNeeded,
        queryApi: queryMyProfile,
        updateCache: updateMyProfileCache,
    },
    useSuspenseMyProfile,
] = createQuery<() => Promise<MyProfile>>({
    name: 'my-profile',
    payloadCreator: () => profileLoader(),
});

export function initProfileLoader(loader: ProfileLoader, profile?: MyProfile): void {
    if (profile) {
        updateMyProfileCache({ data: profile });
    }

    profileLoader = loader;
}
